module.exports = __webpack_public_path__ + "img/logo.d71c561e.png";